import { cn } from "@/lib/utils";

interface SammoLogoProps {
  variant?: 'default' | 'white' | 'icon-only';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function SammoLogo({ 
  variant = 'default', 
  size = 'md', 
  className 
}: SammoLogoProps) {
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-12'
  };

  const textColor = variant === 'white' ? 'fill-white' : 'fill-primary';
  
  const iconSize = {
    sm: { width: 24, height: 24, viewBox: '0 0 24 24' },
    md: { width: 32, height: 32, viewBox: '0 0 32 32' },
    lg: { width: 48, height: 48, viewBox: '0 0 48 48' }
  };

  const wordmarkWidth = {
    sm: 80,
    md: 100,
    lg: 140
  };

  if (variant === 'icon-only') {
    return (
      <svg
        className={cn(sizeClasses[size], className)}
        width={iconSize[size].width}
        height={iconSize[size].height}
        viewBox={iconSize[size].viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="sammo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#14C7B7" />
            <stop offset="100%" stopColor="#0D4EA6" />
          </linearGradient>
        </defs>
        <path
          d="M12 2C10.5 2 9.5 3 9 4.5C8.5 6 8.5 8 9.5 9.5C10.5 11 12 11.5 13 11C14 10.5 14.5 9.5 14.5 8C14.5 6.5 14 5 13 4C12.5 3.5 12 2.5 12 2ZM12 12C10 12 8 13 7 15C6 17 6 19.5 7.5 21.5C9 23.5 11.5 24 13.5 23C15.5 22 16.5 20 16.5 18C16.5 16 15.5 14 14 13C13 12.5 12.5 12 12 12ZM6 8C5 8 4 9 3.5 10.5C3 12 3.5 14 5 15C6.5 16 8.5 15.5 9.5 14C10.5 12.5 10.5 10.5 9.5 9C8.5 7.5 7 7.5 6 8ZM18 8C17 7.5 15.5 8 14.5 9.5C13.5 11 14 13 15.5 14C17 15 19 14.5 20 13C21 11.5 20.5 9.5 19.5 8.5C19 8 18.5 8 18 8Z"
          fill="url(#sammo-gradient)"
        />
      </svg>
    );
  }

  return (
    <svg
      className={cn(sizeClasses[size], className)}
      width={iconSize[size].width + wordmarkWidth[size]}
      height={iconSize[size].height}
      viewBox={`0 0 ${iconSize[size].width + wordmarkWidth[size]} ${iconSize[size].height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="sammo-gradient-full" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#14C7B7" />
          <stop offset="100%" stopColor="#0D4EA6" />
        </linearGradient>
      </defs>
      <g>
        <path
          d="M12 2C10.5 2 9.5 3 9 4.5C8.5 6 8.5 8 9.5 9.5C10.5 11 12 11.5 13 11C14 10.5 14.5 9.5 14.5 8C14.5 6.5 14 5 13 4C12.5 3.5 12 2.5 12 2ZM12 12C10 12 8 13 7 15C6 17 6 19.5 7.5 21.5C9 23.5 11.5 24 13.5 23C15.5 22 16.5 20 16.5 18C16.5 16 15.5 14 14 13C13 12.5 12.5 12 12 12ZM6 8C5 8 4 9 3.5 10.5C3 12 3.5 14 5 15C6.5 16 8.5 15.5 9.5 14C10.5 12.5 10.5 10.5 9.5 9C8.5 7.5 7 7.5 6 8ZM18 8C17 7.5 15.5 8 14.5 9.5C13.5 11 14 13 15.5 14C17 15 19 14.5 20 13C21 11.5 20.5 9.5 19.5 8.5C19 8 18.5 8 18 8Z"
          fill="url(#sammo-gradient-full)"
        />
      </g>
      <text
        x={iconSize[size].width + 8}
        y={iconSize[size].height * 0.7}
        className={cn('font-bold', textColor)}
        style={{ fontFamily: 'Manrope, sans-serif', fontSize: size === 'sm' ? '16px' : size === 'md' ? '20px' : '28px' }}
      >
        Sammo
      </text>
    </svg>
  );
}